import { Inject, Injectable, forwardRef } from '@angular/core';
import { NgbModal }   from '@ng-bootstrap/ng-bootstrap';

import { ApiService }        from '../api/api.service';
import { MyobAccountsModel } from './models/myob.accounts';
import { SyncMyobComponent } from './myob.sync.component';

@Injectable({
  providedIn: 'root'
})
export class MyobService {
  constructor (
    @Inject(forwardRef(() => ApiService)) private apiService : ApiService,
    private modalService: NgbModal
  ) {}

  checkExistingIntegrations () : Promise<string> {
    return this.apiService.get('/company/accounting_ids_exist/myob');
  }

  clearID () : Promise<any> {
    return this.apiService.post('/company/clear_accounting_contact_ids', {
      accounting_integration: 'myob',
      confirmation          : 'CLEAR IDS'
    });
  }

  getOptions () : Promise<MyobAccountsModel> {
    return this.apiService.get('/myob/accounts');
  }

  shareAccount ( shareAccountFlag : boolean ) : Promise<any> {
    return this.apiService.get('/company/share_accounting', [ shareAccountFlag ? 't' : 'f' ]);
  }

  sync () : Promise<any> {
    return this.modalService.open(SyncMyobComponent).result;
  }
}
